module.exports = __webpack_public_path__ + "static/media/room2.13f844b1.jpg";